
export default class SesseionTab{

    constructor(){
        this.$session = document.querySelector('.js-session');
        this._init();
    }


    _init(){
        
        [...document.querySelectorAll('.js-session-tab')].forEach($tab=>{
            const key = $tab.getAttribute('data-key');

            $tab.addEventListener('click', ()=>{
                this.$session.setAttribute('data-key', key);
            });
        });
    }
}